import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatDate, formatPhoneNumber} from "page/util/helpers";

export default function Main() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);

    const page = searchParams.get('page') || "1";

    const navigate = useNavigate();

    const requestSearch = (e) => {
        const params = {};
        params.page = page;

        axios.get(`/admin/notices`, { params: params })
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    }

    const requestDelete = (id) => {
        if (window.confirm("삭제하시겠습니까?")) {
            (async () => {
                await axios.delete(`/admin/notices/${id}`)
                window.location.reload();
            })();
        }
    }

    const requestToggleShow = (id, isShow) => {
        (async () => {
            await axios.put(`/admin/notices/${id}/show`, null, { params: { isShow } });
            setContents(prev => prev.map(item => item.id === id ? { ...item, isShow } : item));
        })();
    }

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }

    useEffect(() => {
        requestSearch();
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">공지사항 관리</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>
                                                <button type="button"
                                                        className="btn btn-outline-info btn-sm"
                                                        style={{marginRight: '20px'}}
                                                        onClick={ () => {
                                                            navigate(`/page/app/notice/detail`)
                                                        }}>
                                                    추가
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{marginTop: '0px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>제목</th>
                                                    <th>링크</th>
                                                    <th>노출 설정</th>
                                                    <th>등록일</th>
                                                    <th>보기</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents && contents.map(item => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{item.title}</td>
                                                                <td>
                                                                    <Link to={item.linkUrl} target="_blank">{item.linkUrl}</Link>
                                                                </td>
                                                                <td>
                                                                    <div className="custom-control custom-switch custom-switch-on-success" style={{marginLeft: "20px"}}>
                                                                        <input
                                                                            type="checkbox"
                                                                            className="custom-control-input"
                                                                            id={`noticeShowSwitch${item.id}`}
                                                                            checked={item.isShow}
                                                                            onChange={(event) => requestToggleShow(item.id, event.target.checked)}
                                                                        />
                                                                        <label className="custom-control-label" htmlFor={`noticeShowSwitch${item.id}`}>
                                                                            {
                                                                                item.isShow
                                                                                    ? <span>노출(ON)</span>
                                                                                    : <span>노출(OFF)</span>
                                                                            }
                                                                        </label>
                                                                    </div>
                                                                </td>
                                                                <td>{formatDate(item.createdAt)}</td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-danger btn-sm"
                                                                            style={{marginRight: '4px'}}
                                                                            onClick={ () => {requestDelete(item.id);}}>
                                                                        삭제
                                                                    </button>
                                                                    <button type="button"
                                                                            className="btn btn-outline-primary btn-sm"
                                                                            onClick={ () => { navigate(`/page/app/notice/detail?id=${item.id}`); }}>
                                                                        보기
                                                                    </button>

                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            paginationDto && <Pagination pager={paginationDto} setPage={setPage}/>
                        }

                    </section>

                </div>
            </div>
        </div>
    );
}
